import { 
  SAVE_DOCUMENTS_IMAGE
} from './sendDocumentsConstants';

export const saveDocumentsImage = (data: any) => {
	return (dispatch:any) => {
    dispatch({type: SAVE_DOCUMENTS_IMAGE, data})
	};
};